import * as Actions from '../../../Modules/CmsActions'
import type { CookieData } from '../../../Types/Api/Cookie'

interface State {
  loading: boolean
  updating: boolean
  edit: CookieData | null
}

// ダミーデータ
const initialState: State = {
  edit: null,
  loading: false,
  updating: false,
}

const UICookieReducer = (state: State = initialState, action) => {
  switch (action.type) {
    case Actions.REQUEST_FETCH_COOKIE:
      return loading(state)
    case Actions.REQUEST_UPDATE_COOKIE:
      return loading(state)
    case Actions.FINISH_FETCH_COOKIE:
      return updateEditInfoWithLoaded(state, action.payload.cookieData)
    case Actions.INTERRUPT_LOADING_COOKIE:
      return interruptUpdating(state)
    case Actions.FINISH_UPDATE_COOKIE:
      return updateEditInfoWithLoaded(state, action.payload.cookieData)
    case Actions.UNLOAD_COOKIE:
      return { ...state, edit: null }
    default:
      return state
  }
}

function loading(state) {
  return { ...state, loading: true }
}

function loaded(state) {
  return { ...state, loading: false }
}

function updateEditInfoWithLoaded(state, cookieData) {
  const updated = {
    ...state,
    edit: cookieData,
  }
  return loaded(updated)
}

function interruptUpdating(state) {
  const updatedState = { ...state, updating: false }
  return loaded(updatedState)
}

export default UICookieReducer
